import { render } from "./TheImgGallery.vue?vue&type=template&id=0a379ed1&scoped=true&ts=true"
import script from "./TheImgGallery.vue?vue&type=script&lang=ts"
export * from "./TheImgGallery.vue?vue&type=script&lang=ts"

import "./TheImgGallery.vue?vue&type=style&index=0&id=0a379ed1&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a379ed1"]])

export default __exports__